import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { scrollToTopValidate,PageTitle } from "../../general/Helpers/SettingHelper";
import { cmscontentURL } from '../../general/Config/Config';

import { GET_CMSLIST,GET_ACTIVATECMS } from '../../../actions';
var Parser = require('html-react-parser');
class List extends Component {
  
  constructor(props)
  {
    super(props); 
    this.state = {
      cmslist:'',
      totalRecord:0
    };

    var qs = require('qs');
    var admin_id = localStorage.getItem("admin_id");
    var postobject = {
    activePage: 1,
    search_all: '',
    admin_id: admin_id
    };

    this.props.getCmsList(qs.stringify(postobject));

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);


    }

   
   componentDidMount() {
      document.title = PageTitle('CMS List');
      if(localStorage.getItem('admin_id') === null){
      this.props.history.push('/');
      }
   }

    handlePageChange(pageNumber) {
     // console.log(`active page is ${pageNumber}`);
      this.setState({activePage: pageNumber});

      var qs = require('qs');

      var admin_id = localStorage.getItem("admin_id");

      var postobject = {
        activePage: pageNumber,
        search_all: this.state.search_all,
        admin_id: admin_id
      };
      this.props.getCmsList(qs.stringify(postobject))
    }

    handleInputChange(event) {
    const {name, value} = event.target;      
    this.setState({
      [name]: value
    });
    
  }
   handleFormSubmit = () => {
        
          this.setState({Loading:true});
          var qs = require('qs');
          const formPayload = this.state;
           var admin_id = localStorage.getItem("admin_id");
          var postObject = {             
            activePage   : 1,
            search_all : formPayload.search_all,
            admin_id: admin_id         
          };
          //console.log(postObject);
          this.props.getCmsList(qs.stringify(postObject));
        
    } 


   componentWillReceiveProps(Props){

    if (Object.keys(Props.cmslist).length > 0) {
      if (Props.cmslist[0]["status"] === "success") {
        /*this.setState({
          cmslist: Props.cmslist[0]["cmslist"],
        });*/
         this.setState({ totalRecord : Props.cmslist[0].records_count, cmslist: Props.cmslist[0]["cmslist"] }, function() {
            this.cmslist();
         });
      }
    }
	
	if(Props.priorityupdate !==  this.props.priorityupdate){
      if (Props.priorityupdate[0]["status"] === "success") {
         this.props.getCmsList();
      }
    }

      if(Props.cmsactive !== this.props.cmsactive){
      if (Props.cmsactive[0]["status"] === "success") {
              var qs = require('qs');
              var admin_id = localStorage.getItem("admin_id");
              var postobject = {
              activePage: 1,
              search_all: '',
              admin_id: admin_id
              };

              this.props.getCmsList(qs.stringify(postobject));

      }
    }

	
   }
   
activateuser(id, status){
  let stat = ''
    if(status == 'Inactive'){
      stat = "A";
    }else{
      stat = "I";
    }
        var qs = require('qs');
        var postObject = {
          admin_id : localStorage.getItem("admin_id"),
          id  :id,
          status: stat
        };
      this.props.getActivateCms(qs.stringify(postObject));
}
  cmslist() {

    var cmslist = this.props.cmslist[0];
    if (cmslist != "undefined" && cmslist != null) {

      if (cmslist.status == "success") {

        if (Object.keys(cmslist).length > 0) {
          const vehiclelistDetails = cmslist.cmslist.map(
            (cmslist, Index) => {
              let sno = Index+1;
              console.log(cmslist.status)
              if(cmslist.status == 'A'){
                var status = 'Active';
              }else{
                  status = 'Inactive';
              }

            var string = '';
            if (cmslist.landing_content!=='' && cmslist.landing_content.length > 25) {
              string = cmslist.landing_content.substring(0, 24) + "...";
              var stripedHtml = string.replace(/<[^>]+>/g, '');
            }

          let cmsImg;
          let preview;
          if (cmslist.landing_logo!== null && cmslist.landing_logo!== '') {
              cmsImg = cmscontentURL + "/" + cmslist.landing_logo;
              preview = <img className="img_class" src={cmsImg} alt="" style={{height: "26px"}}/>;
          }

			       var istyle = { width: 100};
              return (
                <tr key={cmslist.id}>
                    <td>{sno}</td>
                    <td>{cmslist.name}</td>
                    <td>{stripedHtml}</td>
                    <td>{preview}</td>
                    <td>{status}</td>
                    <td className="actiongroup">
                      <Link to={{ pathname: '/cms/edit/'+cmslist.id}} className="" title="Duplicate">  <i className="fa fa-edit" aria-hidden="true"></i></Link>
                       {(status == 'Active'?<Link onClick={this.activateuser.bind(this, cmslist.id, status)} className="" title="Status"><i className="fa fa-unlock" aria-hidden="true"></i></Link>:<Link onClick={this.activateuser.bind(this, cmslist.id, status)} className="" title="Status"><i className="fa fa-lock" aria-hidden="true"></i></Link>)}     
                    </td>
                </tr>
              );
            }
          );
          return vehiclelistDetails;
        }
      } else {

        return (
          <tr>
            <td colspan="6" className="v-align-nr">
              No Result
            </td>
          </tr>
        );

      }
    }

  }
  
  render() {

    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="landing_cms" />  
      
      <div className="content"> 
        <div className="content-wrapper">
            <div className="car-listing-wrap">

              <div className="listing-header">
                <div className="title">
                  <h3>Plugin Content</h3>
                </div>

                <div className="search-list">
                   <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                    <div className="search-inner">
                      <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                     <button className="" type="submit">Submit</button>
                    <div className="erroremail"></div>
                  </div>
                 </form>
                </div>
                {this.state.totalRecord < 5 && 
                  <div className="add_button">  
                      <a className="add" href='/cms-add'>Add</a> 
                  </div>
                }  
              </div>            
              {/*<div className="statusmessage"></div>*/}

              <div className="car-listing-row">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>S.NO</th>
                      <th>Name</th>
                      <th>Logo Content</th>
                      <th>Logo</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>{this.cmslist()}</tbody>
                </Table>
                <div className="text-center">
                  <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={10}
                  totalItemsCount={this.state.totalRecord}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange.bind(this)}
                  />
                </div>
              </div>

            </div> 
        </div>  
      </div>
      
    </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    cmslist: state.cmslist,
    cmsactive: state.cmsactive
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getCmsList: (formVal) =>{
       dispatch({ type: GET_CMSLIST, formVal});
    },
    getActivateCms: (formPayload) =>{
      dispatch({ type: GET_ACTIVATECMS, formPayload });
    },
  }
}
export default connect(mapStateTopProps, mapDispatchToProps)(withRouter(List));